export default "__VITE_ASSET__CS14NVYF__"